require('../index.scss')
import PropTypes from 'prop-types'

import Accordion from '@/components/Accordion'

import AccessibilityFeaturesSection
  from './components/sections/AccessibilityFeaturesSection'
import ChaptersSection from './components/sections/ChaptersSection'
import DetailsSection from './components/sections/DetailsSection'
import PackageSection from './components/sections/PackageSection'
import TableOfContentsSection
  from './components/sections/TableOfContentsSection'

const DEFAULT_ACTIVE_KEY = 'details'

const Mobile = ({ isPrint, kind }) => {
  const displayAccessibilityTab = kind !== 'Package'

  return (
    <Accordion defaultActiveKey={DEFAULT_ACTIVE_KEY}>
      <DetailsSection />
      {!isPrint && (
        <>
          <TableOfContentsSection />
          <ChaptersSection />
          <PackageSection />
          {displayAccessibilityTab && <AccessibilityFeaturesSection />}
        </>
      )}
    </Accordion>
  )
}

Mobile.propTypes = {
  isPrint: PropTypes.bool.isRequired,
  kind: PropTypes.string
}

export default Mobile
